export function imOpacityGet(ind: number, n: number): number {
  let op = 1;

  op = 1 - 0.2 * ((n - 1 - ind) / 5);
  op = op > 0 ? op : 0.2;

  return op;
}
